const validation = {
  emailIsRequiredField: "Електронна пошта – обов'язкове поле",
  usernameIsRequiredField: "Ім'я користувача – обов'язкове поле",
  passwordIsRequiredField: "Пароль – обов'язкове поле",
  tocIsRequiredField: "Зміст – обов'язкове поле",
  nicknameIsRequiredField: "Нікнейм – обов'язкове поле",
  fillNameIsRequiredField: "Повне ім'я – обов'язкове поле",
  businessTypeIsRequiredField: "Тип бізнесу – обов'язкове поле",
  countryIsRequiredField: "Країна – обов'язкове поле",
  phoneIsRequiredField: "Телефон – обов'язкове поле",
  phoneMustContainOnlyNumbers: 'Телефон має містити лише цифри',
  thereShouldBePhoneOrMessenger: 'Потрібно вказати номер телефону або месенджер',
  nicknameIsNotValid: 'Псевдонім недійсний',
  fullNameIsNotValid: "Повне ім'я недійсне",
  emailMustBeAtLeast: 'Електронна адреса має містити щонайменше 4 символи',
  emailIsNotValid: 'Електронна адреса недійсна',
  passwordMustBeAtLeast: 'Пароль має містити щонайменше 8 символів',
  userNameMustBeAtLeast: "Ім'я користувача має містити щонайменше 3 символи",
  passwordsMustMatch: 'Паролі мають збігатися',
  imageTooLarge: 'Зображення занадто велике',
};
export default validation;
